export var DataPath;
(function (DataPath) {
    let Type;
    (function (Type) {
        Type["Empty"] = "EMPTY";
        Type["Named"] = "NAMED";
    })(Type = DataPath.Type || (DataPath.Type = {}));
    function make(path) {
        if (path.length === 0) {
            return { type: "EMPTY" };
        }
        else if (path.length === 1) {
            return { trail: [], name: path[0], type: "NAMED" };
        }
        else if (path.length === 2) {
            return { trail: [], view: path[0], name: path[1], type: "NAMED" };
        }
        else {
            return {
                trail: path.slice(2, path.length),
                view: path[0],
                name: path[path.length - 1],
                type: "NAMED",
            };
        }
    }
    DataPath.make = make;
    function name(path) {
        return path.name;
    }
    DataPath.name = name;
    function format(path) {
        const parts = [];
        if (path.view == null) {
            parts.push(...path.trail, path.name);
        }
        else {
            parts.push(path.view, ...path.trail, path.name);
        }
        return `[${parts.join('],[')}]`;
    }
    DataPath.format = format;
})(DataPath || (DataPath = {}));
